import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent {

  constructor(private router: Router, public handler: HandlerService, private service: ApiService) { }

  addScript: boolean = false;
  paypalLoad: boolean = true;
  loader: boolean;
  finalAmount: number = Number(sessionStorage.getItem('pay'));
  paymentNbr;


  addPaypalScript() {
    this.addScript = true;
    return new Promise((resolve, reject) => {
      let scripttagElement = document.createElement('script');
      scripttagElement.src = "https://www.paypal.com/sdk/js?client-id=AUe59ugHkKX9kU9Ja-hVqfypwARBzEU2uFau7Z1bLWBGu6hmRikRVZUpT9PDwDmzW1v3oyySBRt3spOX&currency=IND";
      scripttagElement.onload = resolve;
      document.body.appendChild(scripttagElement);
    })
  }

  ngAfterViewChecked(){
    // if (!this.addScript) {
    //   this.addPaypalScript().then(() => {
    //     let thisObj = this;
    //       paypal.Buttons({
    //       createOrder: function (data, actions) {
    //         thisObj.loader=true;
    //         // This function sets up the details of the transaction, including the amount and line item details.
    //         return actions.order.create({
              
    //           purchase_units: [{
    //             amount: {
    //               value:sessionStorage.getItem('pay')
    //             },
    //             payee: {
    //               email_address: sessionStorage.getItem('payee')
    //             }
    //           }]
              
    //         });
    //       },
    //       onApprove: function (data, actions) {
    //         // This function captures the funds from the transaction.
    //         return actions.order.capture().then(function (details) {
    //           thisObj.handler.res('Payment Paid SuccessFully');
    //           var post = {
    //            cost:sessionStorage.getItem('pay'),
    //            paymentMode:2,
    //            paymentRcvdBy: localStorage.getItem("currentUserId")
    //          }
    //         //  thisObj.service.postPaymentDetails(post).subscribe(res => {
    //         //   //  thisObj.handler.res("Payment Details Added Successfully");
    //         //    thisObj.router.navigateByUrl('dashboard');
    //         //   sessionStorage.clear();
    //         // },
    //         // err=>{
    //         //   thisObj.handler.err(err);
             
    //         // })

    //         });
    //       }
    //     }).render('#paypal-button-container');
    //   })
    // }
    // setTimeout(() => {
    //   this.loader=false;
    // }, 500);
  
  }

  ionViewWillLeave(){
    // sessionStorage.clear();
  }
  ionViewWillEnter() {
    this.loader = true;
  }
  submit(){
    let form:any=document.getElementsByTagName('form');
    form.paytm.submit()
  }
}

